import { useSelector } from 'react-redux';
import { emptyObject } from 'ui-components/default-props/empty';
import Global from '../store/global-selectors';

export const doesServiceSupportSameDayFeature = (service) => {
  return service.features?.supportsSameDayService || false;
};

const _doesServiceSupportSameDayFeature = (state, serviceId) => {
  const service = Global.selectSellerServiceById(state, { serviceId }) || emptyObject;
  return doesServiceSupportSameDayFeature(service);
};

export const getIsServiceLocalDelivery = (state, serviceId) => {
  return _doesServiceSupportSameDayFeature(state, serviceId);
};

export const useIsServiceLocalDelivery = (serviceId) => {
  return useSelector((state) => _doesServiceSupportSameDayFeature(state, serviceId));
};
